// extracted by mini-css-extract-plugin
export default {"container":"container__eOgTxWgG","icon":"icon__Pq9pE52N","text":"text__Kl12tREF","link":"link__yG7i6zPd"};